import { render, staticRenderFns } from "./MarkupTitle.vue?vue&type=template&id=0abb71e2&"
import script from "./MarkupTitle.vue?vue&type=script&lang=js&"
export * from "./MarkupTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports